/**
 * Cadencia del processor/cron que escribe `meddream_hourly_metrics`.
 * Definido: cada 5 minutos.
 */
export const MEDDREAM_CRON_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Datos stale si `updatedAt` supera ~3 ciclos del cron (15 min).
 */
export const MEDDREAM_STALE_MS = 3 * MEDDREAM_CRON_INTERVAL_MS;
